export const primaryCategoriesOrder = ['Tee-to-green', 'Putting', 'Biomechanics'];
const teeToGreenSubcategoriesOrder = ['Club', 'Launch', 'Flight'];
const puttingSubcategoriesOrder = ['Club', 'Launch', 'Roll', 'Green', 'Flight'];
const biomechanicsSubcategoriesOrder = ['Alignment', 'Rotations', 'Translations', 'Club'];
export const subCategoriesOrder = {
  'Tee-to-green': teeToGreenSubcategoriesOrder,
  Putting: puttingSubcategoriesOrder,
};
